import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Stack, Heading } = designSystem;

function EmptyState({ title, subtitle }) {
  return (
    <div className="ws-website-design-dialog__empty-state">
      <Stack gap="spacing-2-xs">
        <Heading appearance="low-emphasis" align="center" type="heading-2">
          {title}
        </Heading>
        <Heading appearance="low-emphasis" align="center" type="heading-6">
          {subtitle}
        </Heading>
      </Stack>
    </div>
  );
}

EmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
};

export default EmptyState;
